import { IMapresource } from "../models/Mapresource";

export const getZoomLevels = (tileset: IMapresource["tileSet"]) => {
    return {
        minZoom: tileset.layers[0].href,
        maxZoom: tileset.layers[tileset.layers.length - 1].href
    };
};